import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTheme } from 'styled-components';
import { HeaderBar, HeaderMenu, ProfileContainer } from './Header.styles';
import { useWindow } from '../../hooks';
import { Cell, Row, Hamburger, Progress, UserPicture, Menu, ProfileSummary } from '..';
import { useAppSelector, RootState } from '../../store';
import { apiService, configService } from '../../services';
import { doLogout } from '../../hooks';
import i18n from "../../i18n";
import { UserSettings } from '../UserSettings';
import { LanguageSelector } from '../Translate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';

export const Header: React.FC = () => {

  const { width } = useWindow();
  const { Grid } = useTheme();
  const location = useLocation();
  const userStatus = useAppSelector((state: RootState) => state.userStatus);

  const [isMenuOpen, setMenuOpen] = useState(false);
  const [isProfileOpen, setProfileOpen] = useState(false);

  const isLoggedIn = apiService.instance.isLoggedIn();
  const t = i18n.t;

  const toggleMenu = () => {
    setProfileOpen(false);
    setMenuOpen(!isMenuOpen);
  };

  const toggleProfile = () => {
    setMenuOpen(false);
    setProfileOpen(!isProfileOpen);
  };

  const fullName = userStatus?.displayNameSafe ? userStatus.displayNameSafe : "Loading...";

  var pointsToGo = userStatus?.nextLevelIn - userStatus?.totalPoints;
  var pointsStart = userStatus?.nextLevelIn - userStatus?.currentLevelPoints;
  var pointDifference = pointsStart - pointsToGo;
  var percentage = Math.ceil((pointDifference / pointsStart) * 100);

  const appId = configService.current().theme.Id;
  const appName = configService.current().applicationTitle;

  if (appId === "zebratechnologies") {
    return (<>
      <HeaderBar>
        <div className='container d-flex align-items-center justify-content-between p-0'>
          <Link className='d-block w-100' to="/" title={appName}>
            <img src={`/images/${appId}/Zebra_EMEA_Logo.png`} alt={appName} className='d-block m-x-auto' />
          </Link>


          <div className='menu_mobile'>
            <div className='d-flex align-items-start justify-content-end'>
              <Hamburger $isOpen={isMenuOpen} onClick={toggleMenu} />
            </div>
          </div>

          <div className='menu_desktop'>
            <div className='container'>
              <div className='d-flex flex-column gap-2'>

                <div className='d-flex gap-5 text-nowrap align-items-center justify-content-end p-0'>
                  <UserSettings />
                  <LanguageSelector />
                  <a className='d-block' href="/" title={appName} onClick={doLogout}>
                    {t("user_logout")} <FontAwesomeIcon icon={faAngleRight} />
                  </a>
                </div>

                <div className='d-flex gap-5 justify-content-end'>
                  {location.pathname !== "" && location.pathname !== "/" && <>
                    <Link to="/" className='btn btn-primary'>
                      {t("header_home")}
                      <FontAwesomeIcon icon={faAngleRight} />
                    </Link>
                  </>}
                  {location.pathname !== "/campaigns" && <>
                    <Link to="/campaigns" className='btn btn-primary'>
                      {t("header_campaigns")}
                      <FontAwesomeIcon icon={faAngleRight} />
                    </Link>
                  </>}
                </div>

              </div>
            </div>
          </div>
        </div>
      </HeaderBar>

      <div className={`header-mobile-menu ${isMenuOpen ? "open" : ""}`}>

        {location.pathname !== "" && location.pathname !== "/" && <>
          <Link to="/" onClick={() => toggleMenu()}>
            {t("header_home")}
            <FontAwesomeIcon icon={faAngleRight} />
          </Link>
        </>}
        {location.pathname !== "/campaigns" && <>
          <Link to="/campaigns" onClick={() => toggleMenu()}>
            {t("header_campaigns")}
            <FontAwesomeIcon icon={faAngleRight} />
          </Link>
        </>}
        <UserSettings />
        <LanguageSelector />
        <a className='d-block' href="/" title={appName} onClick={doLogout}>
          {t("user_logout")} <FontAwesomeIcon icon={faAngleRight} />
        </a>
      </div>


    </>
    )
  }


  return (
    <div className='pos-relative'>
      <HeaderBar>
        <Row>
          <Cell className='d-flex align-items-center'>
            <Hamburger $isOpen={isMenuOpen} onClick={toggleMenu} />
          </Cell>
          <Cell className='d-flex align-items-center justify-content-center'>
            <Link className='d-block' to="/">
              <img src={`/images/${appId}/logo.svg`} alt={appName} className='d-block m-x-auto' width={width < Grid.Breakpoints.SM ? 75 : 100} />
            </Link>
          </Cell>
          <Cell className='d-flex justify-content-end'>
            {isLoggedIn && (<ProfileContainer className='w-100'>
              <div className='flex-1 m-right-1'>
                <p className='font-smallprint m-bottom-0 color-white text-center'>{userStatus?.currentLevel}</p>
                <div>
                  {/* <Progress max={userStatus?.nextLevelIn} value={userStatus ? userStatus?.totalPoints : 0} secondaryStyle /> */}
                  <div title={(percentage ? percentage : 0) + "%"}>
                    <Progress max={100} value={percentage} secondaryStyle />
                  </div>
                </div>
              </div>
              <div onClick={toggleProfile}>
                <UserPicture name={fullName} size={2} cssClass='m-x-auto cursor-pointer' />
              </div>
            </ProfileContainer>)}
          </Cell>
        </Row>
        {isMenuOpen && (
          <HeaderMenu position='left'>
            <Menu onMenuItemClick={toggleMenu} />
          </HeaderMenu>
        )}
        {isProfileOpen && isLoggedIn && (
          <HeaderMenu position='right'>
            <ProfileSummary />
          </HeaderMenu>
        )}
      </HeaderBar>
    </div>
  )
}